<script lang="ts">
	import { Slider, Text, CardGrid, SelectCard } from '@Shelly/shelly-design-system';
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';
	import { capFirstChar } from 'src/helpers/utilities';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let actions = []; //both options - select percent level or change rooler/cover state
	export let active_actions = []; // active action must be the one of both provided options

	let showSliderPosition = typeof active_actions[0]?.value === 'number';
	let sliderInitialValue = active_actions[0]?.value;

	const dispatch = createEventDispatcher();

	const mappedActionIcons = {
		0: 'fal fa-blinds-raised',
		1: 'fal fa-hand',
		2: 'fal fa-blinds',
		3: 'fal fa-blinds',
	};

	$: selected_state = active_actions?.[0]?.value || undefined;

	let value = typeof active_actions[0]?.value === 'number' ? active_actions[0]?.value : 0;

	const change_active_act = (act, val) => {
		let doNotDispatch = val === 'position' && typeof active_actions[0]?.value === 'number';

		if (!doNotDispatch) {
			value = act.id === 'roller position' ? value : val;

			showSliderPosition = value === 'position';
			active_actions[0] = {
				name: act.id,
				value: value,
			};

			dispatch('change_active', { new_active: active_actions });
		}

		if (val === 'position' && sliderInitialValue !== 0) {
			value = typeof sliderInitialValue !== 'undefined' ? sliderInitialValue : 0;

			active_actions[0] = {
				name: 'position',
				value,
			};

			dispatch('change_active', { new_active: active_actions });
		}
	};

	const handle_slider_changes = (e, act) => {
		value = e.detail.value;
		sliderInitialValue = value !== sliderInitialValue ? value : sliderInitialValue;

		active_actions[0] = {
			name: act?.id || 'roller position',
			value,
		};

		dispatch('change_active', { new_active: active_actions });
	};

	const _prepare_msg_by_id = (id, _val) => {
		if (id === 'opening_state') {
			return $format('scene_action_device_state', {
				values: { state: $format(`execute_${_val}`) },
			});
		} else {
			return $format('scene_action_roller_state', {
				values: { roller_state: $format(`execute_${_val}`) },
			});
		}
	};
	const a11yProps = {
		ariaLabel: $format('label_adjust_value', { default: 'Adjust value' }),
		ariaLabelValue: value || 0,
	};
</script>

<!-- active_actions[0] returns the state options - 'open', 'stop', 'close', 'position'. -->
<!-- active_actions[1] returns the position option - 'multi_cover_position', 'roller position', 'position'. -->
{#if actions.length > 0}
	<CardGrid gridGap="s" lg={290} sm={270} noPaddingBottom class="mb-l">
		{#each actions[0].values as _val, _i}
			<div class="d-flex">
				<SelectCard
					cardBgColor={$showNewLayout ? 'color-1' : undefined}
					class="width-full"
					type="horizontal"
					variant="radio"
					title={`${_prepare_msg_by_id(actions[0].id, _val)}`}
					icon={mappedActionIcons[_i]}
					selected={selected_state === _val ||
						(active_actions[0]?.name.includes('position') && _i === 3)}
					on:click={() => {
						change_active_act(actions[0], _val);
					}}
				/>
			</div>
		{/each}
	</CardGrid>
	{#if showSliderPosition}
		<Slider
			id="slider-95vwia4"
			{a11yProps}
			{value}
			type="simple"
			min={0}
			max={100}
			on:value_change={(e) => handle_slider_changes(e, actions[1])}
		/>
		<Text styleType="body-small" class="d-flex justify-content-center mt-xs text-bold">
			{capFirstChar($format(actions[1].title))}
			{value || 0}%
		</Text>
	{/if}
{/if}
